<div [id]="id()" data-uitype="map-container" class="w-full h-full relative">
    @if (!isLoaded()) {
    <div
        class="absolute top-0 bottom-0 left-0 right-0 animate-pulse bg-dat-grey-300"
    ></div>
    }
    <div
        [class.opacity-0]="!isLoaded()"
        data-uitype="map"
        class="w-full h-full bg-white"
        #mapContainerEl
    ></div>
</div>
